import React, { useContext } from 'react';
import { Icon } from '@/components/Atoms/Icon/Icon';
import { Flex } from '@/components/Atoms/Flex/Flex';
import { useTranslation } from 'react-i18next';
import { PageContext } from 'src/context/PageContext';
import { format } from 'date-fns';
import styles from './Survey.module.scss';

export function SurveyPendingOpen() {
  const { t } = useTranslation();
  const { survey, questionnaire } = useContext(PageContext);
  const dateRaw = new Date(survey?.start_time || questionnaire?.start_time || '');
  const date = format(dateRaw, 'MMMM d yyyy hh:mm a');
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      <Icon name="calendar" />

      <span className={styles.endScreenMessage}>{t('surveyError.surveyNotOpen', { date })}</span>
    </Flex>
  );
}
